import { render, staticRenderFns } from "./DdFileInput.vue?vue&type=template&id=ab10cd80&"
import script from "./DdFileInput.vue?vue&type=script&lang=js&"
export * from "./DdFileInput.vue?vue&type=script&lang=js&"
import style0 from "./DdFileInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
